import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row q-mt-md filters q-pb-lg section-container bg-white"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex items-center justify-center q-ml-auto" }
const _hoisted_5 = {
  key: 2,
  class: "q-mr-md self-center refresh-btn flex items-center"
}
const _hoisted_6 = {
  key: 1,
  class: "row filters section-container bg-white"
}
const _hoisted_7 = {
  key: 0,
  class: "q-py-xs"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "q-py-xs"
}
const _hoisted_10 = {
  key: 2,
  class: "q-py-xs"
}
const _hoisted_11 = {
  key: 3,
  class: "q-py-xs"
}
const _hoisted_12 = {
  key: 4,
  class: "q-py-xs"
}
const _hoisted_13 = {
  key: 5,
  class: "q-py-xs"
}
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 6,
  class: "q-py-xs"
}
const _hoisted_18 = {
  key: 7,
  class: "q-py-xs"
}
const _hoisted_19 = {
  key: 8,
  class: "q-py-xs"
}
const _hoisted_20 = {
  key: 9,
  class: "q-py-xs"
}
const _hoisted_21 = {
  key: 10,
  class: "q-py-xs"
}
const _hoisted_22 = {
  key: 11,
  class: "q-py-xs"
}
const _hoisted_23 = {
  key: 12,
  class: "q-py-xs"
}
const _hoisted_24 = {
  key: 13,
  class: "q-py-xs"
}
const _hoisted_25 = {
  key: 14,
  class: "q-py-xs"
}
const _hoisted_26 = {
  key: 15,
  class: "q-py-xs"
}
const _hoisted_27 = {
  key: 16,
  class: "q-py-xs"
}
const _hoisted_28 = {
  key: 17,
  class: "q-py-xs"
}
const _hoisted_29 = {
  key: 18,
  class: "q-py-xs"
}
const _hoisted_30 = {
  key: 19,
  class: "q-py-xs"
}
const _hoisted_31 = {
  key: 20,
  class: "q-py-xs"
}
const _hoisted_32 = {
  key: 21,
  class: "q-py-xs"
}
const _hoisted_33 = {
  key: 22,
  class: "q-py-xs q-mr-md"
}
const _hoisted_34 = { class: "q-mr-md self-center" }
const _hoisted_35 = {
  key: 23,
  class: "q-mr-md self-center refresh-btn"
}
const _hoisted_36 = {
  key: 24,
  class: "q-mr-md self-center refresh-btn flex"
}
const _hoisted_37 = { class: "q-mr-md self-center items-center flex refresh-btn" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"1px solid var(--border-color)","width":"100%","padding-top":"40px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_FiltersDialog = _resolveComponent("FiltersDialog")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$q.screen.width < 600)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.hideForStatistics && _ctx.hideForConversions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  debounce: "500",
                  class: "q-mr-lg",
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  "stack-label": "",
                  label: _ctx.$t('name'),
                  square: "",
                  dense: ""
                }, null, 8, ["modelValue", "label"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForOffers && _ctx.hideForCampaigns && _ctx.hideForPostbacks && _ctx.hideForLogs
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.offerId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.offerId) = $event)),
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeFilters('offerId', _ctx.filters.offerId))),
                  dense: "",
                  outlined: "",
                  class: "q-mr-lg",
                  options: _ctx.offers,
                  onFilter: _ctx.getOffers,
                  "option-value": "id",
                  "option-label": "name",
                  label: _ctx.$t('offer'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": "",
                  square: ""
                }, null, 8, ["modelValue", "options", "onFilter", "label", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_btn, {
              label: "Filters",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFiltersDialog = !_ctx.showFiltersDialog)),
              icon: _ctx.heroOutline24AdjustmentsVertical,
              flat: "",
              color: "gray",
              "no-caps": "",
              class: "text-weight-bold toggle-filters-btn"
            }, null, 8, ["icon"])
          ]),
          (!_ctx.hideForOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_q_checkbox, {
                  label: _ctx.$t('only_my_offers'),
                  "model-value": _ctx.filters.affiliateAccess,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeFilters('affiliateAccess', !_ctx.filters.affiliateAccess)))
                }, null, 8, ["label", "model-value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showFiltersDialog)
            ? (_openBlock(), _createBlock(_component_FiltersDialog, {
                key: 3,
                open: _ctx.showFiltersDialog,
                currentFilters: _ctx.filters,
                onChangeFilters: _ctx.submitAll,
                onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showFiltersDialog = false))
              }, null, 8, ["open", "currentFilters", "onChangeFilters"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$q.screen.width >= 600)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.hideForStatistics && _ctx.hideForConversions && _ctx.hideForPayments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_q_input, {
                  outlined: "",
                  square: "",
                  dense: "",
                  debounce: "500",
                  class: "col-4 q-mr-lg",
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.search) = $event)),
                  "stack-label": "",
                  label: _ctx.$t('name')
                }, null, 8, ["modelValue", "label"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hideForOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.offerId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.offerId) = $event)),
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeFilters('offerId', _ctx.filters.offerId))),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.offers,
                  onFilter: _ctx.getOffers,
                  "option-value": "id",
                  "option-label": "name",
                  label: _ctx.$t('offer'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "options", "onFilter", "label", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForStatistics &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.trafficProperty,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.trafficProperty) = $event)),
                  onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeFilters('trafficProperty', _ctx.filters.trafficProperty))),
                  outlined: "",
                  square: "",
                  dense: "",
                  "use-input": "",
                  label: _ctx.$t('labels'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.trafficProperties,
                  onFilter: _ctx.getTrafficProperties
                }, null, 8, ["modelValue", "label", "dropdown-icon", "options", "onFilter"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hideForCampaigns && _ctx.hideForOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.campaignId,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.campaignId) = $event)),
                  onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeFilters('campaignId', _ctx.filters.campaignId))),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.campaigns,
                  onFilter: _ctx.getCampaigns,
                  "option-value": "id",
                  "option-label": "name",
                  label: _ctx.$t('campaign'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "options", "onFilter", "label", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForStatistics &&
          _ctx.hideForConversions &&
          _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForClickLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.eventType,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.eventType) = $event)),
                  onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onChangeFilters('eventType', _ctx.filters.eventType))),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.postbackEventTypes,
                  "option-value": "id",
                  "option-label": "name",
                  label: _ctx.$t('event'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["modelValue", "options", "label", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hideForPostbacks && _ctx.hideForPayments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.geoId,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.geoId) = $event)),
                  onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onChangeFilters('geoId', _ctx.filters.geoId))),
                  outlined: "",
                  dense: "",
                  square: "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.geos,
                  onFilter: _ctx.getGeos,
                  "option-value": "id",
                  "option-label": "name",
                  label: _ctx.$t('geos'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, {
                  "selected-item": _withCtx((scope) => [
                    _createElementVNode("span", _hoisted_14, [
                      _createElementVNode("img", {
                        style: {"user-select":"none","display":"initial"},
                        class: "q-mr-sm",
                        height: "10",
                        width: "15",
                        src: 
                `http://purecatamphetamine.github.io/country-flag-icons/3x2/${scope.opt.isoCode}.svg`
              
                      }, null, 8, _hoisted_15),
                      _createTextVNode(" " + _toDisplayString(scope.opt.name), 1)
                    ])
                  ]),
                  option: _withCtx((scope) => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, _mergeProps({ class: "flex items-center" }, scope.itemProps, _toHandlers(scope.itemEvents)), {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"user-select":"none","display":"initial"},
                          class: "q-mr-sm",
                          height: "10",
                          width: "15",
                          src: 
                `http://purecatamphetamine.github.io/country-flag-icons/3x2/${scope.opt.isoCode}.svg`
              
                        }, null, 8, _hoisted_16),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, {
                              innerHTML: scope.opt.name
                            }, null, 8, ["innerHTML"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040)), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onFilter", "label", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hideForOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.offerCategoryId,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filters.offerCategoryId) = $event)),
                  onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onChangeFilters('offerCategoryId', _ctx.filters.offerCategoryId))),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.offerCategories,
                  onFilter: _ctx.getOfferCategories,
                  "option-value": "id",
                  "option-label": "name",
                  label: _ctx.$t('category'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "options", "onFilter", "label", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForStatistics &&
          _ctx.hideForConversions &&
          _ctx.hideForCampaigns &&
          _ctx.hideForPostbacks &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.rewardType,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.filters.rewardType) = $event)),
                  onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onChangeFilters('rewardType', _ctx.filters.rewardType))),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.rewardTypes,
                  "stack-label": "",
                  label: _ctx.$t('reward_type'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["modelValue", "options", "label", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hideForConversions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_q_select, {
                  dense: "",
                  modelValue: _ctx.filters.status,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.filters.status) = $event)),
                  onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChangeFilters('status', _ctx.filters.status))),
                  outlined: "",
                  square: "",
                  class: "col-4 q-mr-lg",
                  label: _ctx.$t('status'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  options: _ctx.leadStatuses,
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["modelValue", "label", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hideForConversions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.rewardType,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.filters.rewardType) = $event)),
                  onBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onChangeFilters('rewardType', _ctx.filters.rewardType))),
                  outlined: "",
                  dense: "",
                  square: "",
                  class: "col-4 q-mr-lg",
                  "stack-label": "",
                  label: _ctx.$t('reward_type'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  options: _ctx.rewardTypesWithReg,
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["modelValue", "label", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hideForOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_q_select, {
                  dense: "",
                  square: "",
                  modelValue: _ctx.filters.trafficSourceName,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.filters.trafficSourceName) = $event)),
                  onBlur: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onChangeFilters('trafficSourceName', _ctx.filters.trafficSourceName))),
                  onFilter: _cache[27] || (_cache[27] = (value, updateFn) => _ctx.getTrafficSources(value, updateFn)),
                  outlined: "",
                  label: _ctx.$t('traffic_source'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.trafficSourceNames
                }, null, 8, ["modelValue", "label", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForStatistics &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.markupType,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.filters.markupType) = $event)),
                  onBlur: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onChangeFilters('markupType', _ctx.filters.markupType))),
                  outlined: "",
                  dense: "",
                  square: "",
                  disable: true,
                  class: "col-4 q-mr-lg",
                  label: "Устройства",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  options: _ctx.markupTypes,
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.landingId,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.filters.landingId) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  label: _ctx.$t('landings'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  class: "col-4 q-mr-lg",
                  options: _ctx.landings,
                  onBlur: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onChangeFilters('landingId', _ctx.filters.landingId))),
                  onFilter: _cache[32] || (_cache[32] = (value, updateFn) => _ctx.getLandings(value, updateFn, true)),
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "label", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForStatistics &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.preLandingId,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.filters.preLandingId) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "q-mr-lg",
                  "stack-label": "",
                  label: "Прелендинги",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  options: _ctx.preLandings,
                  onBlur: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onChangeFilters('preLandingId', _ctx.filters.preLandingId))),
                  onFilter: _cache[35] || (_cache[35] = (value, updateFn) => _ctx.getLandings(value, updateFn, false)),
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.sid1,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.filters.sid1) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  "stack-label": "",
                  label: "Sub 1",
                  class: "q-mr-lg",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  options: _ctx.sids1,
                  onBlur: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onChangeFilters('sid1', _ctx.filters.sid1))),
                  onFilter: _cache[38] || (_cache[38] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids1')),
                  "option-value": "value",
                  "option-label": "value",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.sid2,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.filters.sid2) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "q-mr-lg",
                  options: _ctx.sids2,
                  label: "Sub 2",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  onBlur: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onChangeFilters('sid2', _ctx.filters.sid2))),
                  onFilter: _cache[41] || (_cache[41] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids2')),
                  "option-value": "value",
                  "option-label": "value",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "options", "dropdown-icon"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.sid3,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.filters.sid3) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  "stack-label": "",
                  label: "Sub 3",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  class: "q-mr-lg",
                  options: _ctx.sids3,
                  onBlur: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onChangeFilters('sid3', _ctx.filters.sid3))),
                  onFilter: _cache[44] || (_cache[44] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids3')),
                  "option-value": "value",
                  "option-label": "value",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.sid4,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.filters.sid4) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  class: "q-mr-lg",
                  label: "Sub 4",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  options: _ctx.sids4,
                  onBlur: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onChangeFilters('sid4', _ctx.filters.sid4))),
                  onFilter: _cache[47] || (_cache[47] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids4')),
                  "option-value": "value",
                  "option-label": "value",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.sid5,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.filters.sid5) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  label: "Sub 5",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  class: "q-mr-lg",
                  options: _ctx.sids5,
                  onBlur: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onChangeFilters('sid5', _ctx.filters.sid5))),
                  onFilter: _cache[50] || (_cache[50] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids5')),
                  "option-value": "value",
                  "option-label": "value",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.sid6,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.filters.sid6) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  label: "Sub 6",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  class: "q-mr-lg",
                  options: _ctx.sids6,
                  onBlur: _cache[52] || (_cache[52] = ($event: any) => (_ctx.onChangeFilters('sid6', _ctx.filters.sid6))),
                  onFilter: _cache[53] || (_cache[53] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids6')),
                  "option-value": "value",
                  "option-label": "value",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForConversions &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.sid7,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.filters.sid7) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  label: "Sub 7",
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  "stack-label": "",
                  class: "q-mr-lg",
                  options: _ctx.sids7,
                  onBlur: _cache[55] || (_cache[55] = ($event: any) => (_ctx.onChangeFilters('sid7', _ctx.filters.sid7))),
                  onFilter: _cache[56] || (_cache[56] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids7')),
                  "option-value": "value",
                  "option-label": "value",
                  "emit-value": "",
                  "map-options": "",
                  "use-input": ""
                }, null, 8, ["modelValue", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (
        _ctx.hideForConversions &&
          _ctx.hideForCampaigns &&
          _ctx.hideForOffers &&
          _ctx.hideForPostbacks &&
          _ctx.hideForLogs &&
          _ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.filters.groupBy,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.filters.groupBy) = $event)),
                  outlined: "",
                  square: "",
                  dense: "",
                  "stack-label": "",
                  label: _ctx.$t('groupBy'),
                  "dropdown-icon": _ctx.heroOutline24ChevronDown,
                  onBlur: _cache[58] || (_cache[58] = ($event: any) => (_ctx.onChangeFilters('groupBy', _ctx.filters.groupBy))),
                  class: "col-4 q-mr-lg",
                  options: _ctx.getGroupByOptions,
                  "option-value": "id",
                  "option-label": "name",
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["modelValue", "label", "dropdown-icon", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hideForOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_DatePicker, {
                  id: "1",
                  onChangeDate: _ctx.onChangeDate,
                  from: _ctx.filters.dateFrom,
                  to: _ctx.filters.dateTo
                }, null, 8, ["onChangeDate", "from", "to"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              unelevated: "",
              "icon-right": _ctx.heroOutline24Check,
              color: "primary",
              class: "q-btn__main-size text-weight-bold",
              label: _ctx.$t('apply'),
              onClick: _ctx.submitAll
            }, null, 8, ["icon-right", "label", "onClick"])
          ]),
          (
        !_ctx.hideForStatistics ||
          !_ctx.hideForConversions ||
          !_ctx.hideForLogs ||
          !_ctx.hideForPayments
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_35))
            : _createCommentVNode("", true),
          (!_ctx.hideForOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(_component_q_checkbox, {
                  label: _ctx.$t('only_my_offers'),
                  "model-value": _ctx.filters.affiliateAccess,
                  onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.onChangeFilters('affiliateAccess', !_ctx.filters.affiliateAccess)))
                }, null, 8, ["label", "model-value"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              color: "gray",
              outline: "",
              class: "btn-refresh",
              icon: _ctx.heroOutline24ArrowPath,
              onClick: _ctx.resetFilters
            }, null, 8, ["icon", "onClick"])
          ]),
          _hoisted_38
        ]))
      : _createCommentVNode("", true)
  ], 64))
}